export enum CapMode {
  RELATIVE_MODE = 'Relative',
  ABSOLUTE_MODE = 'Absolute',
}
